import { ErrorInfo } from "react";
export function logError(error: Error, context: { errorInfo: ErrorInfo }) {
    // this will be picked up by Grafana and logged as an error
    console.error(error, context);
}
